import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useSEO } from "@/lib/seo";

export default function Blog() {
  useSEO({
    title: "Guides & Insights | Training Basket Blog",
    description: "Practical guides on IT certifications, careers and skill-building from Training Basket experts.",
    canonical: "/blog",
  });
  const embedded = window.INITIAL_DATA?.type === "blog_list" ? window.INITIAL_DATA.payload : null;
  const [posts, setPosts] = useState(embedded?.posts || []);
  const [loading, setLoading] = useState(!embedded);

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data.posts)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-14 min-h-[100vh]" data-testid="blog-page">
      <p className="text-xs font-semibold uppercase tracking-widest text-rose-600">Guides & insights</p>
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 mt-2">IT Training Guides &amp; Career Insights</h1>

      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">{[1, 2, 3].map((i) => <div key={i} className="h-72 rounded-2xl bg-slate-100 animate-pulse" />)}</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {posts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="group rounded-2xl border border-slate-200 bg-white overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-testid={`blog-card-${p.slug}`}>
              <img src={p.image} alt={p.title} className="aspect-video w-full object-cover" loading="lazy" />
              <div className="p-6">
                <span className="inline-flex px-3 py-1 rounded-full text-xs font-semibold bg-rose-100 text-rose-800 border border-rose-200/50">{p.category}</span>
                <h2 className="font-bold text-slate-900 mt-3 text-lg leading-snug group-hover:text-rose-700 transition-colors">{p.title}</h2>
                <p className="text-sm text-slate-500 mt-2 line-clamp-2">{p.excerpt}</p>
                <p className="text-xs text-slate-400 mt-4">{p.author}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
